import { ArrowDown } from "lucide-react";

export default function MobileCTA() {
  return (
    <div className="mobile-cta-bar">
      <a href="#booking"
        className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-xl bg-gradient-to-r from-[#f1cb82] to-[#b77a31] text-[#1b1108] font-black text-sm shadow-lg shadow-[#d7a85c]/20">
        RESERVE COUPLE SESSION — ₹5
        <ArrowDown className="w-4 h-4" />
      </a>
    </div>
  );
}
